import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LogoComponent } from '../logo/logo.component';
import { FlameAnimationComponent } from './flame-animation.component';

@Component({
  selector: 'app-flame-logo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LogoComponent, FlameAnimationComponent],
  template: `
    <div class="relative" style="height: 320px; width: 320px;">
      <app-logo class="absolute inset-0 w-full h-full" />
      <!-- The static logo is already visible underneath, so hold the ~600KB wasm download and
           animation startup until the browser is idle; otherwise it competes with LCP on mobile. -->
      @defer (on idle) {
        <app-flame-animation class="absolute inset-0 w-full h-full" />
      }
    </div>
  `,
})
export class FlameLogoComponent {}
